export const rotateCoordsTable = (x, y, xm, ym, a) => {
  // Normalize angle to range [0, 360)
  let normalizedAngle = a % 360;
  if (normalizedAngle < 0) {
    normalizedAngle += 360;
  }

  // Convert to radians
  const aRad = (normalizedAngle * Math.PI) / 180;

  // Translate point to origin (relative to rotation center)
  const dx = x - xm;
  const dy = y - ym;

  // Apply 2D rotation formula (counter-clockwise)
  const xr = dx * Math.cos(aRad) - dy * Math.sin(aRad) + xm;
  const yr = dx * Math.sin(aRad) + dy * Math.cos(aRad) + ym;

  return { x: xr, y: yr };
};


export const rotateCoordsSection = (x, y, xm, ym, a) => {
  // Normalize angle to range [0, 360)
  let normalizedAngle = a % 360;
  if (normalizedAngle < 0) {
    normalizedAngle += 360;
  }

  // Convert to radians
  const aRad = (normalizedAngle * Math.PI) / 180;

  // Apply rotation
  const cos = Math.cos(aRad),
    sin = Math.sin(aRad),
    xr = (x - xm) * cos + (y - ym) * sin + xm,
    yr = -(x - xm) * sin + (y - ym) * cos + ym;

  return { x: xr, y: yr };
};